import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from "primereact/calendar";
import { FilterMatchMode } from "primereact/api";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import axios from "axios";

import {
    SERVICE_LOCATION, GET_INVOICED_PAYAPP_MEASURESCOUNT_BY_SITE,
    GET_INVOICED_PAYAPP_MEASURES_FOR_SITE, EXPORT_SAGE_BATCH_PAYAPPS, DOWNLOAD_INVOICE_WITH_DOWNLOAD_OPTIONS
} from "../constants/endpoints";

import { INVOICE_DOWNLOAD_TYPES } from "../constants/newBuildConstants";
import { INVOICE_DOWNLOAD_SUCCESS } from "../constants/errors";

import "./../assets/styles/table.css";
import "./../assets/styles/worksheets.css";

const InvoicedPayApps = (props) => {
    const toast = useRef(null);

    const { data } = props;
    const userName = (data !== undefined && data !== null) ? data.data.userDetails.userName : "";
    const userDepot = (data !== undefined && data !== null) ? data.data.userDetails.depot : "";

    const [loading, setLoading] = useState(false);
    const [sitesData, setSitesData] = useState(null);
    const [selectedSite, setSelectedSite] = useState(null);
    const [showMeasures, setShowMeasures] = useState(false);
    const [measuresData, setMeasuresData] = useState(null);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [minToDate, setMinToDate] = useState(null);
    const [disableGoButton, setDisableGoButton] = useState(false);
    const [eligibleExportBatchData, setEligibleExportBatchData] = useState(null);
    const [showEligibleExportBatch, setShowEligibleExportBatch] = useState(false);
    const [disableNewExportBatchButton, setDisableNewExportBatchButton] = useState(true);
    const [selectedExportBatchData, setSelectedExportBatchData] = useState(null);
    const [disabaleProcesExportButton, setDisabaleProcesExportButton] = useState(true);
    const [selectedDownloadType, setSelectedDownloadType] = useState(null);
    const [downloadTypeList, setDownloadTypeList] = useState([]);
    const [disableDownloadButton, setDisableDownloadButton] = useState(true);

    const [siteDataPage, setSiteDataPage] = useState(0);

    useEffect(() => {
        const currentDate = new Date();
        const previousDate = new Date(currentDate);
        previousDate.setDate(currentDate.getDate() - 2);
        setFromDate(previousDate);
        setToDate(currentDate);
        getSitesData(previousDate, currentDate);
    }, [])

    const getFormattedDate = (dateToFormat) => {
        const year = dateToFormat.getFullYear();
        const month = String(dateToFormat.getMonth() + 1).padStart(2, "0");
        const day = String(dateToFormat.getDate()).padStart(2, "0");
        const formatedDate = `${year}-${month}-${day}`;
        return formatedDate;
    }

    const handleGo = () => {
        getSitesData(fromDate, toDate);
    }

    const handleFromDate = (e) => {
        const dateSelected = e.value;
        setFromDate(dateSelected);
        setMinToDate(dateSelected);
        setToDate(null);
        setDisableGoButton(true);
    }

    const handleToDate = (e) => {
        const dateSelected = e.value;
        setToDate(dateSelected);
        setDisableGoButton(false);
    }

    const getSitesData = (selectedFromDate, selectedToDate) => {
        setLoading(true);
        const endPoint = SERVICE_LOCATION + GET_INVOICED_PAYAPP_MEASURESCOUNT_BY_SITE;
        const formatedFromDate = getFormattedDate(selectedFromDate);
        const formatedToDate = getFormattedDate(selectedToDate)
        const requestedData = {
            startDate: formatedFromDate,
            endDate: formatedToDate
        }
        axios.post(endPoint, requestedData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            setLoading(false);
            clearFilter();
            if (response.data.isSuccess) {
                const processedData = response.data.data.measuresCountBySite;
                var filteredByDepot = userDepot === "NONE" ? processedData : processedData.filter((item) => item.depotName === userDepot);
                const exportBatch = filteredByDepot.filter(m => m.sageExportBatch === 0);
                exportBatch.length === 0 ? setDisableNewExportBatchButton(true) : setDisableNewExportBatchButton(false);
                setEligibleExportBatchData(exportBatch);
                setSitesData(filteredByDepot);
            }
            else if (!response.data.isSuccess) {
                setSitesData(null);
            }
        }).catch((error) => {
            setLoading(false)
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
        })
    }

    const getMeasuresData = (payAppNo) => {
        setLoading(true);
        const endPoint = SERVICE_LOCATION + GET_INVOICED_PAYAPP_MEASURES_FOR_SITE;
        const requestedData = {
            systemId: payAppNo
        }
        axios.post(endPoint, requestedData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            if (response.data.isSuccess) {
                setMeasuresData(response.data.data.invoicingMeasures);
            }
            else if (!response.data.isSuccess) {
                setMeasuresData(null);
            }
            setShowMeasures(true);
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
        })
    }

    const handleNewExportBatch = () => {
        eligibleExportBatchData.length === 0 ? setShowEligibleExportBatch(false) : setShowEligibleExportBatch(true);
    }

    const handleEligibaleExportBatchData = (e) => {
        setSelectedExportBatchData(e.value);
        e.value.length > 0 ? setDisabaleProcesExportButton(false) : setDisabaleProcesExportButton(true);
    }

    const handleProcessExport = () => {
        setLoading(true);
        var selectedAppIds = [];
        selectedExportBatchData.forEach(acc => {
            const appIds = {
                appId: acc.payAppNo
            }
            selectedAppIds.push(appIds);
        })
        var requestDate = {
            appIds: selectedAppIds,
            userName: userName
        }
        const endPoint = SERVICE_LOCATION + EXPORT_SAGE_BATCH_PAYAPPS;
        axios.post(endPoint, requestDate, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            setLoading(false);
            if (response.data.isSuccess) {
                getSitesData(fromDate, toDate);
                setShowMeasures(false);
                setShowEligibleExportBatch(false);
                handleBackToAccounts();
                toast.current.show({ severity: "success", summary: "Success", detail: response.data.data, life: 5000 });
            }
            if (!response.data.isSuccess) {
                toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
            }
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
        })
    }

    // Site search functionality
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const [globalFilterValue, setGlobalFilterValue] = useState("");

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const clearFilter = () => {
        setFilters({ global: { value: null, matchMode: FilterMatchMode.CONTAINS } });
        setGlobalFilterValue("");
    };

    const renderHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <label htmlFor="from-date">From</label>
                    <Calendar id="from-date" name="from-date" value={fromDate} onChange={handleFromDate} showIcon dateFormat="dd/mm/yy" />
                </div>
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <label htmlFor="to-date">To</label>
                    <Calendar id="to-date" name="to-date" value={toDate} onChange={handleToDate} minDate={minToDate} showIcon dateFormat="dd/mm/yy" />
                </div>
                <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1 padt-19">
                    <Button id="go" label="Go" disabled={disableGoButton} onClick={handleGo} />
                </div>
                <div className="col-12 col-sm-7 col-md-7 col-lg-7 col-xl-7 padt-15">
                    <div className="flex justify-content-end txt-right">
                        <Button className="mar-r-10" id="newExportBatch" label="New Export Batch" disabled={disableNewExportBatchButton} onClick={handleNewExportBatch} />
                        <Button type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} tooltip="clear filters" tooltipOptions={{ position: "bottom" }} />
                        <span className="p-input-icon-left marl-20">
                            <i className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    const header = renderHeader();
    // Search site functionality Ends here

    const exportBatchHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 padr-20">
                    <Button className="btn-secondary" onClick={handleProcessExport} disabled={disabaleProcesExportButton}>Process Export</Button>
                </div>
            </div>
        )
    }

    const onRowSelect = (e) => {
        setSelectedSite(e.data);
        getMeasuresData(e.data.payAppNo);
    }

    const handleBackToAccounts = () => {
        setShowMeasures(false);
        setShowEligibleExportBatch(false);
        setDisabaleProcesExportButton(true);
        setSelectedExportBatchData(null);
        setMeasuresData(null);
        setSelectedDownloadType(null);
        setDownloadTypeList([]);
        setDisableDownloadButton(true);
    }

    const handleDownloadTypeSelection = (e) => {
        const selectedList = e.value;
        setSelectedDownloadType(selectedList);
        const docs = selectedList.map(item => item.downloadType);
        setDownloadTypeList(docs);
        setDisableDownloadButton(false);
    }

    const handleDownloadPDF = () => {
        setLoading(true);
        const requestData = {
            payAppNo: selectedSite.payAppNo,
            downloadType: downloadTypeList
        }
        const endPoint = SERVICE_LOCATION + DOWNLOAD_INVOICE_WITH_DOWNLOAD_OPTIONS;
        axios.post(endPoint, requestData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            setLoading(false);
            if (response.data.isSuccess) {
                if (response.data.data.downloadedInvoice.length > 0) {
                    (response.data.data.downloadedInvoice).forEach(workcard => {
                        const base64 = workcard.chunks.join("");
                        const base64String = "data:application/pdf;base64," + base64;
                        const linkSource = base64String;
                        const downloadLink = document.createElement("a");
                        const fileName = workcard.fileName;
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    });
                    setDownloadTypeList([]);
                    setSelectedDownloadType(null);
                    setDisableDownloadButton(true);
                }
                toast.current.show({ severity: "success", summary: "Success", detail: INVOICE_DOWNLOAD_SUCCESS, life: 5000 });
            }
            else if (!response.data.isSuccess) {
                toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 5000 });
            }
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 5000 });
        })
    }

    const measuresDataHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 padr-20">
                    <div className="flex flex-column gap-2 fitter-feild">
                        <MultiSelect value={selectedDownloadType} onChange={handleDownloadTypeSelection} options={INVOICE_DOWNLOAD_TYPES} optionLabel="downloadType"
                            placeholder="Select Download PDF" maxSelectedLabels={3} className="w-full md:w-14rem" display="chip" />
                    </div>
                </div>
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <Button id="download" label="Download Invoice" disabled={disableDownloadButton} onClick={handleDownloadPDF} />
                </div>
            </div>
        )
    }

    const sitesTablePageChange = (event) => {
        setSiteDataPage(event.first / event.rows);
    };

    return (
        <div className={`app ${loading ? "disabled" : ""}`}>
            {
                loading &&
                <div className="spinner-overlay">
                    <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                </div>
            }
            <Toast ref={toast} />

            {!showMeasures && !showEligibleExportBatch &&
                <div className="worksheets-section">
                    <h4>Invoiced Pay Apps</h4>
                    <DataTable className="font-12" value={sitesData} datakey="systemId" paginator rows={10} first={siteDataPage * 10}
                        onPage={sitesTablePageChange} metaKeySelection={false} filters={filters} header={header}
                        selectionMode="single" selection={selectedSite} onSelectionChange={(e) => setSelectedSite(e.value)}
                        onRowSelect={onRowSelect}
                        globalFilterFields={["clientAccount", "clientName", "site", "contractType", "systemId", "siteRefNo", "depot", "depotName",
                            "payAppNo", "siteApplicationNumber", "sageInvoice", "invoiceDate", "totalRevenue", "taxCode", "taxRate",
                            "createdDate", "createdBy", "measuresCount"]}
                        scrollable tableStyle={{ minWidth: "150rem" }} emptyMessage="No processed payapp accounts available.">
                        <Column field="sageExportBatch" header="Sage Export Batch"></Column>
                        <Column field="clientAccount" header="Client Account"></Column>
                        <Column field="clientName" header="Client Name"></Column>
                        <Column field="site" header="Site"></Column>
                        <Column field="contractType" header="ContractType"></Column>
                        <Column field="systemId" header="SystemId" hidden></Column>
                        <Column field="siteRefNo" header="Site RefNo"></Column>
                        <Column field="depot" header="DepotCode" hidden></Column>
                        <Column field="depotName" header="Depot" hidden></Column>
                        <Column field="payAppNo" header="Sales Order"></Column>
                        <Column field="siteApplicationNumber" header="Site App No"></Column>
                        <Column field="sageInvoice" header="Sage Invoice"></Column>
                        <Column field="invoiceDate" header="Invoice Date"></Column>
                        <Column field="totalRevenue" header="Total Revenue(£)"></Column>
                        <Column field="taxCode" header="Tax Code"></Column>
                        <Column field="taxRate" header="Tax Rate(%)"></Column>
                        <Column field="createdDate" header="Created"></Column>
                        <Column field="createdBy" header="Created By"></Column>
                        <Column field="measuresCount" header="Measures"></Column>
                    </DataTable>
                </div>
            }

            {showMeasures && !showEligibleExportBatch &&
                <div className="worksheets-section">
                    <div className="row">
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padt-10 txt-bold">
                            {selectedSite.clientAccount} - {selectedSite.site}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <div className="flex justify-content-end txt-right" onClick={handleBackToAccounts}>
                                <Button id="back" label="Back to Accounts" link onClick={handleBackToAccounts} />
                            </div>
                        </div>
                    </div>
                    <DataTable className="font-12" value={measuresData} dataKey="measureId" paginator rows={10} rowsPerPageOptions={[10, 20, 50]}
                        tableStyle={{ minWidth: "50rem" }} header={measuresDataHeader} emptyMessage="No processed accounts available to view.">
                        <Column field="site" header="Site" hidden></Column>
                        <Column field="worksheetNo" header="WorksheetNo" hidden></Column>
                        <Column field="plotId" header="SystemId" hidden></Column>
                        <Column field="plotNo" header="Plot"></Column>
                        <Column field="plotDescription" header="Description" hidden></Column>
                        <Column field="product" header="Measure"></Column>
                        <Column field="measureId" header="MeasureId"></Column>
                        <Column field="quantity" header="Quantity"></Column>
                        <Column field="revenue" header="Revenue(£)"></Column>
                        <Column field="paymentCardRequired" header="PaymentCardRequired"></Column>
                    </DataTable>
                </div>
            }

            {showEligibleExportBatch && !showMeasures &&
                <div className="worksheets-section">
                    <div className="row">
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padt-10 txt-bold">
                            <h4>New Sage Export</h4>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <div className="flex justify-content-end txt-right">
                                <Button id="back" label="Back to Accounts" link onClick={handleBackToAccounts} />
                            </div>
                        </div>
                    </div>
                    <DataTable className="font-12" value={eligibleExportBatchData} datakey="systemId" paginator rows={10} rowsPerPageOptions={[10, 20, 50]}
                        selection={selectedExportBatchData} onSelectionChange={handleEligibaleExportBatchData} header={exportBatchHeader}
                        scrollable tableStyle={{ minWidth: "150rem" }} emptyMessage="No accounts available to export.">
                        <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
                        <Column field="sageExportBatch" header="Sage Export Batch"></Column>
                        <Column field="clientAccount" header="Client Account"></Column>
                        <Column field="clientName" header="Client Name"></Column>
                        <Column field="site" header="Site"></Column>
                        <Column field="systemId" header="SystemId" hidden></Column>
                        <Column field="siteRefNo" header="Site RefNo"></Column>
                        <Column field="depot" header="DepotCode" hidden></Column>
                        <Column field="depotName" header="Depot" hidden></Column>
                        <Column field="payAppNo" header="Sales Order"></Column>
                        <Column field="siteApplicationNumber" header="Site App No"></Column>
                        <Column field="sageInvoice" header="Sage Invoice"></Column>
                        <Column field="invoiceDate" header="Invoice Date"></Column>
                        <Column field="totalRevenue" header="Total Revenue(£)"></Column>
                        <Column field="taxCode" header="Tax Code"></Column>
                        <Column field="taxRate" header="Tax Rate(%)"></Column>
                        <Column field="createdDate" header="Created"></Column>
                        <Column field="createdBy" header="Created By"></Column>
                        <Column field="measuresCount" header="Measures"></Column>
                    </DataTable>
                </div>
            }
        </div>
    )
}

export default InvoicedPayApps;